/**
 * CSGCombiner3D registration: the parser.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCSGCombiner3D } from './parser';
const cSGCombiner3DRegistration = {
    typeName: 'CSGCombiner3D',
    parser: parseCSGCombiner3D,
};
nodeRegistry.register(cSGCombiner3DRegistration);
//# sourceMappingURL=index.js.map